/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getRadiationTypes } from 'app/entities/radiation-type/radiation-type.reducer';
import { createEntity, getEntity, reset, updateEntity } from './radiation-dosimetry.reducer';

export const RadiationDosimetryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const radiationTypes = useAppSelector(state => state.radiationType.entities);
  const radiationDosimetryEntity = useAppSelector(state => state.radiationDosimetry.entity);
  const loading = useAppSelector(state => state.radiationDosimetry.loading);
  const updating = useAppSelector(state => state.radiationDosimetry.updating);
  const updateSuccess = useAppSelector(state => state.radiationDosimetry.updateSuccess);

  const handleClose = () => {
    navigate(`/radiation-dosimetry${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getRadiationTypes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...radiationDosimetryEntity,
      ...values,
      radiationTypes: mapIdList(values.radiationTypes),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...radiationDosimetryEntity,
          radiationTypes: radiationDosimetryEntity?.radiationTypes?.map(e => e.id.toString()),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.radiationDosimetry.home.createOrEditLabel" data-cy="RadiationDosimetryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.radiationDosimetry.home.createOrEditLabel">
              Create or edit a RadiationDosimetry
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="radiation-dosimetry-id"
                  label={translate('tinyMedicRestApp.radiationDosimetry.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.radiationDosimetry.name')}
                id="radiation-dosimetry-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiationDosimetry.description')}
                id="radiation-dosimetry-description"
                name="description"
                data-cy="description"
                type="text"
                validate={{
                  maxLength: { value: 3000, message: translate('entity.validation.maxlength', { max: 3000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiationDosimetry.doseDistribution')}
                id="radiation-dosimetry-doseDistribution"
                name="doseDistribution"
                data-cy="doseDistribution"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiationDosimetry.doseCalculationAlgorithm')}
                id="radiation-dosimetry-doseCalculationAlgorithm"
                name="doseCalculationAlgorithm"
                data-cy="doseCalculationAlgorithm"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiationDosimetry.doseGrid')}
                id="radiation-dosimetry-doseGrid"
                name="doseGrid"
                data-cy="doseGrid"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiationDosimetry.active')}
                id="radiation-dosimetry-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiationDosimetry.cursor')}
                id="radiation-dosimetry-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiationDosimetry.lastUpdated')}
                id="radiation-dosimetry-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiationDosimetry.microSec')}
                id="radiation-dosimetry-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiationDosimetry.timestampEntry')}
                id="radiation-dosimetry-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiationDosimetry.radiationType')}
                id="radiation-dosimetry-radiationType"
                data-cy="radiationType"
                type="select"
                multiple
                name="radiationTypes"
              >
                <option value="" key="0" />
                {radiationTypes
                  ? radiationTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/radiation-dosimetry" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RadiationDosimetryUpdate;
